<template lang="pug">
    .page
        //- Create Modal
        a-modal(v-model="addVisible"
            title="创建API Key"
            @ok="handleCreateOk"
            ok-text="创建"
            cancel-text="取消")
            a-form-model(:model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }")
                a-form-model-item(label="名称")
                    a-input(v-model="form.name" placeholder="输入API Key名称")
                a-form-model-item(label="所属用户")
                    a-select(v-model="form.user" placeholder="选择用户")
                        a-select-option(v-for="user in users" :key="user._id" :value="user._id") {{ user.name }}
                a-form-model-item(label="过期时间")
                    a-date-picker(v-model="form.expiresAt" show-time format="YYYY-MM-DD HH:mm:ss" placeholder="选择过期时间（可选）")

        //- Edit Drawer
        a-drawer(:visible="editVisible"
            title="编辑API Key"
            width="500"
            @close="editVisible=false"
        )
            a-form-model(:model="editForm" layout="vertical")
                a-form-model-item(label="名称")
                    a-input(v-model="editForm.name" placeholder="输入API Key名称")
                a-form-model-item(label="过期时间")
                    a-date-picker(v-model="editForm.expiresAt" show-time format="YYYY-MM-DD HH:mm:ss" placeholder="选择过期时间（可选）")
                a-form-model-item(label="是否启用")
                    a-switch(v-model="editForm.isActive")

            a-button(type="primary" style="margin-top:20px" @click="submitEdit") 保存修改

        .ctl-bar
            a-button(type="primary"
                @click="handleCreate"
                style=" margin-right:20px")
                a-icon(type="plus")
                span 创建API Key

            a-button(type="primary"
                style=" margin-right:20px"
                @click="getData")
                a-icon(type="redo")
                span 刷新

        a-table(:columns="columns",
            size="small"
            :dataSource="items"
            :pagination="{ pageSize: 50 }"
            rowKey="_id")
            template(slot="user" slot-scope="text")
                span {{ text ? text.name : '-' }}

            template(slot="createdBy" slot-scope="text")
                span {{ text ? text.name : '-' }}

            template(slot="isActive" slot-scope="text")
                a-tag(:color="text ? 'green' : 'red'") {{ text ? '已启用' : '已禁用' }}

            template(slot="expiresAt" slot-scope="text")
                span {{ text ? new Date(text).toLocaleString() : '永不过期' }}

            template(slot="lastUsedAt" slot-scope="text")
                span {{ text ? new Date(text).toLocaleString() : '从未使用' }}

            template(slot="key" slot-scope="text, record")
                span {{ showKeys[record._id] ? text : '••••••••••••••••' }}
                a-icon(:type="showKeys[record._id] ? 'eye-invisible' : 'eye'" @click="toggleKeyVisibility(record._id)" style="margin-left: 8px; cursor: pointer;")
                a-icon(type="copy" @click="copyKey(text)" style="margin-left: 8px; cursor: pointer;")

            template(slot="action" slot-scope="record")
                a(@click="handleEdit(record)" style="margin-right: 12px;")
                    a-icon(type="edit")
                    span 编辑
                a-divider(type="vertical")
                a-popconfirm(title="确认删除该API Key吗？"
                    ok-text="确认"
                    cancel-text="取消"
                    @confirm="submitDelete(record._id)")
                    a(style="color: red; margin-right: 12px;")
                        a-icon(type="delete")
                        span 删除
</template>

<script>
export default {
    data() {
        return {
            addVisible: false,
            editVisible: false,
            showKeys: {},

            form: {
                name: '',
                user: '',
                expiresAt: null
            },

            editForm: {
                _id: '',
                name: '',
                expiresAt: null,
                isActive: true
            },

            columns: [
                {
                    title: '名称',
                    dataIndex: 'name',
                    sorter: (a, b) => a.name.localeCompare(b.name),
                },
                {
                    title: 'Key',
                    dataIndex: 'key',
                    scopedSlots: { customRender: 'key' }
                },
                {
                    title: '所属用户',
                    dataIndex: 'user',
                    scopedSlots: { customRender: 'user' }
                },
                {
                    title: '创建者',
                    dataIndex: 'createdBy',
                    scopedSlots: { customRender: 'createdBy' }
                },
                {
                    title: '创建时间',
                    dataIndex: 'createdAt',
                    sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
                    customRender: (text) => new Date(text).toLocaleString()
                },
                {
                    title: '过期时间',
                    dataIndex: 'expiresAt',
                    scopedSlots: { customRender: 'expiresAt' },
                    sorter: (a, b) => new Date(a.expiresAt || 0) - new Date(b.expiresAt || 0)
                },
                {
                    title: '状态',
                    dataIndex: 'isActive',
                    scopedSlots: { customRender: 'isActive' }
                },
                {
                    title: '最后使用时间',
                    dataIndex: 'lastUsedAt',
                    scopedSlots: { customRender: 'lastUsedAt' },
                    sorter: (a, b) => new Date(a.lastUsedAt || 0) - new Date(b.lastUsedAt || 0)
                },
                {
                    title: '操作',
                    scopedSlots: { customRender: 'action' },
                }
            ],
            items: [],
            users: []
        };
    },
    mounted() {
        this.getUsers();
        this.getData();
    },
    methods: {
        toggleKeyVisibility(id) {
            this.$set(this.showKeys, id, !this.showKeys[id]);
        },
        async copyKey(key) {
            try {
                await navigator.clipboard.writeText(key);
                this.$message.success('API Key已复制到剪贴板');
            } catch (e) {
                this.$message.error('复制失败，请手动复制');
            }
        },
        handleCreate() {
            this.form = {
                name: '',
                user: '',
                expiresAt: null
            };
            this.addVisible = true;
        },
        handleCreateOk() {
            if (!this.form.name || !this.form.user) {
                this.$message.error('名称和所属用户不能为空');
                return;
            }

            const data = {
                name: this.form.name,
                user: this.form.user,
                expiresAt: this.form.expiresAt ? this.form.expiresAt.toISOString() : null
            };

            this.$api.request('POST', 'apikeys', data)
            .then(res => {
                this.$message.success('创建成功');
                this.addVisible = false;
                this.getData();
            });
        },
        handleEdit(record) {
            this.editForm = {
                _id: record._id,
                name: record.name,
                expiresAt: record.expiresAt ? new Date(record.expiresAt) : null,
                isActive: record.isActive
            };
            this.editVisible = true;
        },
        submitEdit() {
            const data = {
                name: this.editForm.name,
                isActive: this.editForm.isActive,
                expiresAt: this.editForm.expiresAt ? this.editForm.expiresAt.toISOString() : null
            };

            this.$api.request('PUT', `apikeys/${this.editForm._id}`, data)
            .then(res => {
                this.$message.success('更新成功');
                this.editVisible = false;
                this.getData();
            });
        },
        submitDelete(id) {
            this.$api.request('DELETE', `apikeys/${id}`)
            .then(res => {
                this.$message.success('删除成功');
                this.getData();
            })
        },
        getData() {
            this.$api.request('GET', 'apikeys')
            .then(res => {
                this.items = res.data;
            })
        },
        getUsers() {
            this.$api.request("GET", 'users')
            .then(res => {
                this.users = res.data;
            });
        }
    }
};
</script>

<style lang="less" scoped>
.ctl-bar {
    margin-bottom: 20px;
}
</style>
